import services from "../../services/services";
import moment from "moment";

const state = {
    contractors: [],
};

const mutations = {
    'SET_CONTRACTORS'(state, data) {
        for (const contractor of data.contractors) {
            const invoiceIndex = data.invoices.findIndex((inv) => {
                return inv.contractorID === `/api/contractors/${contractor.id}`;
            });
            if (data.invoices[invoiceIndex] === undefined) {
                state.contractors.push({...contractor, invoice: {}});
            } else {
                state.contractors.push({...contractor, invoice: data.invoices[invoiceIndex]});
            }

            if (invoiceIndex !== -1) {
                data.invoices.splice(invoiceIndex, 1);
            }
        }

        for (const invoice of data.invoices) {
            state.contractors.push({invoice});
        }

        state.contractors.sort((a, b) => {
            return ('' + a.lastName).localeCompare(b.lastName);
        });
    },
    'RESET_CONTRACTORS'(state) {
        state.contractors = [];
    }
}

const actions = {
    getContractors: ({commit, dispatch}, {seasonFrom, seasonTo}) => {
        return services.getContractors().then(response => {
            if (response.status === 200) {
                if ({seasonFrom} === undefined) {
                    seasonFrom = moment().format();
                    seasonTo = moment().format();
                } 

                dispatch('getInvoices', {seasonFrom, seasonTo}).then((res) => {
                    commit('RESET_CONTRACTORS');
                    commit('SET_CONTRACTORS', {contractors: response.data, invoices: res.data});
                });
            }
            return response.status;
        });
    },
    addContractor: ({commit, dispatch}, {payload, seasonFrom, seasonTo}) => {
        services.addContractor(payload).then(response => {
            if (response.status === 201) {
                services.getContractors().then(response => {
                    if (response.status === 200) {
                        dispatch('getInvoices', {seasonFrom, seasonTo}).then((res) => {
                            commit('RESET_CONTRACTORS');
                            commit('SET_CONTRACTORS', {contractors: response.data, invoices: res.data});
                        });
                    }
                });
            }
        });
    },
    deleteContractor: ({commit}, payload) => {
        services.deleteContractor(payload).then(response => {
            if (response.status === 200) {
                services.getContractors().then((response) => {
                    if (response.status === 200) {
                        commit('SET_CONTRACTORS', response.data);
                    }
                });
            }
        });
    },
    updateContractor: ({commit, dispatch}, {payload, seasonFrom, seasonTo}) => {
        services.updateContractor(payload).then(response => {
            if (response.status === 200) {
                services.getContractors().then(response => {
                    if (response.status === 200) {
                        dispatch('getInvoices', {seasonFrom, seasonTo}).then((res) => {
                            commit('RESET_CONTRACTORS');
                            commit('SET_CONTRACTORS', {contractors: response.data, invoices: res.data});
                        });
                    }
                });
            }
        });
    },
}

const getters = {
    contractors: state => {
        return state.contractors;
    },
}


export default {
    state, mutations, actions, getters
}
